<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">公司名称</span>
            <el-input
              v-model="listQuery.companyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务代表</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleSalesManFocus" @change="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
           <div class="filter-box">
            <span class="label">外包商</span>
            <el-input
              v-model="listQuery.outsourceCompany"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <!-- <div class="filter-box">
            <span class="label">审批状态</span>
            <el-select :filterable="true" v-model="listQuery.status" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @keyup.enter="handleFilter">
              <el-option
                v-for="item in ReviewStatusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div> -->
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>

        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <TableList
       ref="tableListRef"
        v-loading="listLoading"
        :dataList="list"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :isShowPagination="false"
        :canRefresh="false"
        :canChangeColumn="false"
        @command-change="handleCommand"
      >
        <template v-slot:operation-action="scope">
          <el-link
            v-permission="{ pkey: `${permissionName}_APPROVAL` }"
            v-if="scope.row.status === '待审批'"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            审批
          </el-link>
        </template>
      </TableList>
      <el-pagination
        class="mt-20"
        v-show="total > 0"
        :total="total"
        v-model:currentPage="listQuery.page"
        :page-size="listQuery.size"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </div>
    <div v-if="dialogFormVisible">
      <div style="display:flex">
        <FormComponent
          :id="activeId"
          :api="'outsourceCompanyAccount'"
          :detail="activeRow"
        />
      </div>
      <div class="dialog-footer mt-20">
        <el-button @click="dialogFormVisible = false" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit"
        >
          通过
        </el-button>
        <el-button
          type="danger"
          :loading="submitLoading"
          @click="handleReject"
        >
          拒绝
        </el-button>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import { cloneDeep } from 'lodash'
import { ElMessage, ElMessageBox } from 'element-plus'

import { reviewInfoById, reviewApprove, reviewReject, getOutsourceFeePage } from '@/apis/OutsourceFee'
import { getDropdown } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from './Form.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from '@/views/business/outsourceCompany/accountInfo/FieldFrom'
import { TableField } from './FieldTable'
import mixin from '@/mixins/index'
import { defaultDate, pageVo, pageSizes } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Approvaloutsourcefee',
  components: {
    FormComponent,
    TableList
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref(null)
    const dataMap = reactive({
      TableName: TableName.TABLE_APPROVAL_OUTSOURCE_FEE,
      permissionName: permissionName.APPROVAL_OUTSOURCE_FEE,
      initFormData: cloneDeep(FromFieldData),
      originFromFieldData: cloneDeep(FromFieldData),
      targetFromFieldData: cloneDeep(FromFieldData),
      columnAllData: TableField,

      activeId: 0,
      activeRow: null,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        businessNo: undefined,
        businessName: undefined,
        businessModel: undefined,
        outsourceCompany: undefined,
        salesManId: undefined,
        invoiceStatus: undefined,
        startTime: '',
        status: 2,
        endTime: '',
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,

      salesManOption: [],
      statusOption: [],
      ReviewStatusOption: [
        {
          id: 2,
          mark: '待审批',
          selected: true
        },
        {
          id: 3,
          mark: '退回'
        },
        {
          id: 4,
          mark: '已通过'
        }
      ],
      UserPayTypeOption: [],
      submitLoading: false,
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getOutsourceFeePage({ ...dataMap.listQuery, pageType: 1 }).then((res: any) => {
          dataMap.list = res.data
            ? res.data.map((item: any) => {
              return {
                ...item,
                customerCompany: item.business.customerCompany,
                ticketCompany: item.business.ticketCompany,
                businessNo: item.business.no,
                businessName: item.business.name,
                businessBrand: item.business.brand,
                businessAmount: item.business.amount,
                businessModel: item.business.model,
                businessSerial: item.business.serial,
                businessUnit: item.business.unit,
                accountAlias: item.account?.alias
              }
            })
            : []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch((error: any) => {
          console.log(error, 2222)
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          businessNo: undefined,
          businessName: undefined,
          businessModel: undefined,
          outsourceCompany: undefined,
          salesManId: undefined,
          invoiceStatus: undefined,
          startTime: defaultDate[0],
          status: 2,
          endTime: defaultDate[1],
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const {
          startTime,
          endTime
        } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleUpdate(row: any) {
        dataMap.activeId = row.id
        reviewInfoById(row.id).then((res: any) => {
          dataMap.activeRow = res
          dataMap.dialogFormVisible = true
        })
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      handleReject() {
        ElMessageBox.prompt(
          '拒绝理由：',
          '提交',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            cancelButtonClass: 'el-button--danger'
          }
        ).then((params: any) => {
          const { value } = params
          reviewReject(dataMap.activeId, { comment: value }).then(() => {
            dataMap.dialogFormVisible = false
            dataMap.getList()
            ElMessage.success('操作成功！')
          })
        })
      },
      async handleSubmit() {
        try {
          await reviewApprove(dataMap.activeId)
          dataMap.dialogFormVisible = false
          dataMap.getList()
          ElMessage.success('操作成功！')
        } catch (err:any) {
          console.log(err, 'err')
        }
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      }
    })
    const { mixinData } = mixin(dataMap)

    onMounted(async() => {
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      // getDropdownByType('ReviewStatus').then((res: any) => {
      //   dataMap.ReviewStatusOption = res
      // })
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), tableListRef }
  }
})
</script>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
</style>
